import { Component, Input, OnInit } from '@angular/core';
import { GoogleMapsService } from '@core/services/core/google-maps.service';
import { LatLng } from '@models/google-location';
import { UrlHelper } from 'src/app/core/services/helpers/url-helper.service';
import { ContextService } from '../../../core/services/core/context.service';
import { MapHelperService } from '../../../core/services/helpers/map-helper.service';

@Component({
  selector: 'static-map',
  templateUrl: 'static-map.component.html',
  styleUrls: ['static-map.component.scss']
})
export class StaticMapComponent implements OnInit {
  @Input() location: LatLng;
  @Input() icon = '';
  @Input() zoom = 15;
  @Input() showFabButton = true;
  options: google.maps.MapOptions = {};
  mapPWAStyles = [];
  hasLoaded: boolean;

  constructor(
    public ctx: ContextService,
    private urlHelper: UrlHelper,
    private mapHelper: MapHelperService,
    private googleMapsService: GoogleMapsService
  ) {}

  ngOnInit() {
    this.googleMapsService.ready().then(() => {
      this.hasLoaded = true;
      this.mapPWAStyles = this.mapHelper.getMapStyles();
      this.options.styles = this.mapPWAStyles;
      this.options.scrollwheel = false;
      this.options.draggable = false;
      this.options.clickableIcons = false;
    });
  }

  openGoogleMap() {
    const url = `https://www.google.com/maps/search/?api=1&query=${this.location.lat},${this.location.lng}`;
    this.urlHelper.open(url);
  }
}
